import { ArchiveIcon } from '@heroicons/react/outline';
import PropTypes from 'prop-types';
import { Pagination } from '../Pagination/Pagination';

export const Table = ({ data, columns, totalPages, currentPage, onPageChange, onRowClick }) => {
  if (!data?.length) {
    return (
      <div className="bg-white/10 dark:bg-white/5 text-white/60 h-80 flex justify-center items-center flex-col rounded-xl border border-white/10 backdrop-blur-md shadow-inner">
        <ArchiveIcon className="h-16 w-16 text-white/20" />
        <h4 className="text-white/60 text-sm">You have no entries at the moment</h4>
      </div>
    );
  }

  return (
    <div className="rounded-2xl overflow-hidden border border-white/10 bg-white/5 dark:bg-white/5 backdrop-blur-md shadow-md">
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead className="bg-white/10 dark:bg-white/10 border-b border-white/10">
            <tr>
              {columns.map((column, index) => (
                <th
                  key={column.title + index}
                  className="px-6 py-4 text-left text-xs font-black text-white/80 uppercase"
                >
                  {column.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((entry, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => onRowClick && onRowClick(entry)}
                className="transition-all cursor-pointer hover:bg-white/10 dark:hover:bg-white/10 border-b border-white/5"
              >
                {columns.map(({ Cell, field }, colIndex) => (
                  <td
                    key={colIndex}
                    className="px-4 py-3 whitespace-nowrap text-xs font-medium text-white/70"
                  >
                    {Cell ? <Cell entry={entry} /> : entry[field]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="mx-5 flex justify-between items-center py-4">
          <span className="text-xs text-white/60">
            {data.length > 0
              ? `Displaying 1 - ${data.length} records of page ${currentPage} of ${totalPages}`
              : '1 Page'}
          </span>
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      Cell: PropTypes.func,
      field: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};
